import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Modal from 'Components/modal';
import Button from 'Components/button';
import loc from 'Components/languages';
import styles from './ModalQuantityDiscount.less';

class ModalQuantity extends PureComponent {
	constructor() {
		super();
		this.state = {
			quantity: 1,
		};
		this.modalStyles = {
			content: {
				left: 'calc(50% - 250px)',
				right: 'calc(50% - 250px)',
				maxHeight: '150px',
			},
		};
		this.onChangeQuantityHandler = this.onChangeQuantityHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
		this.onCancelHandler = this.onCancelHandler.bind(this);
	}

	componentDidUpdate(prevProps) {
		const quantity = this.props.quantity;
		const prevQuantity = prevProps.quantity;
		if (quantity && quantity !== prevQuantity) {
			this.setState({
				quantity,
			});
		}
	}

	onChangeQuantityHandler(e) {
		this.setState({
			quantity: e.target.value,
		});
	}

	onSubmitHandler(e) {
		e.preventDefault();
		const { onChange, onToggle } = this.props;
		const { quantity } = this.state;
		let data = {
			quantity: parseInt(quantity),
		};
		onChange(data);
		onToggle();
	}

	onCancelHandler() {
		const { onToggle } = this.props;
		onToggle();
	}

	render() {
		const { isOpen, onToggle } = this.props;
		const { quantity } = this.state;
		return (
			<Modal
				isOpen={ isOpen }
				onToggle={ onToggle }
				style={ this.modalStyles }
			>
				<form className="uk-form-stacked" onSubmit={ this.onSubmitHandler }>
					<div className="uk-margin">
						<label className={ classnames('uk-form-label', styles.label) }>{ loc.qty }</label>
						<div className="uk-form-controls">
							<input
								className={ classnames('uk-input', styles.inputQty) }
								type="text"
								placeholder={ loc.qty }
								value={ quantity }
								onChange={ this.onChangeQuantityHandler }
							/>
						</div>
					</div>

					<div className="uk-margin-small-top uk-text-center uk-flex">
						<div className={ classnames('uk-width-1-2', styles.buttonColumnLeft) }>
							<Button
								text={ loc.cancel }
								theme="primary"
								type="button"
								className="uk-width-1-1"
								onClick={ this.onCancelHandler }
							/>
						</div>
						<div className={ classnames('uk-width-1-2', styles.buttonColumnRight) }>
							<Button
								text={ loc.apply }
								theme="primary"
								type="submit"
								className="uk-width-1-1"
								onClick={ this.onSubmitHandler }
							/>
						</div>
					</div>
				</form>
			</Modal>
		);
	}
}

ModalQuantity.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	quantity: PropTypes.number.isRequired,
	onToggle: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default ModalQuantity;